import { mergeStyleSets } from "@fluentui/react";

export const usePanelClasses = mergeStyleSets({
  container: {
    top: "60px",
  },
  isAuthenticated: {
    top: "60px",
    height: 200
  }
});
